import { Mail } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function ReportDistribution() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Mail className="h-6 w-6" /> Report Distribution
        </h1>
        <p className="text-sm text-muted-foreground">
          Scheduled email + Slack delivery — Phase 3
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Not yet implemented</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground space-y-3">
          <p>
            This page is reserved for Phase 3 of the Reporting Engine. It will let
            you:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Pick a saved report (created via the Chat page)</li>
            <li>Attach a cron schedule and recipient list</li>
            <li>Deliver runs by email (Gmail API) or Slack (bot)</li>
            <li>See the last-run audit log and any delivery failures</li>
          </ul>
          <p>
            Until Phase 3 lands, use the <strong>Chat</strong> page to run
            questions on-demand.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
